import { createAction, props } from '@ngrx/store';
import { GroupedPropertiesResponse } from '../../models/property-section.model';

// Load Properties
export const loadProperties = createAction(
  '[Property] Load Properties',
  props<{ filters?: any }>()
);

export const loadPropertiesSuccess = createAction(
  '[Property] Load Properties Success',
  props<{ properties: any[] }>()
);

export const loadPropertiesFailure = createAction(
  '[Property] Load Properties Failure',
  props<{ error: any }>()
);

// Load Property
export const loadProperty = createAction('[Property] Load Property', props<{ id: string }>());

export const loadPropertySuccess = createAction(
  '[Property] Load Property Success',
  props<{ property: any }>()
);

export const loadPropertyFailure = createAction(
  '[Property] Load Property Failure',
  props<{ error: any }>()
);

// Create Property
export const createProperty = createAction(
  '[Property] Create Property',
  props<{ property: any }>()
);

export const createPropertySuccess = createAction(
  '[Property] Create Property Success',
  props<{ property: any }>()
);

export const createPropertyFailure = createAction(
  '[Property] Create Property Failure',
  props<{ error: any }>()
);

// Update Property
export const updateProperty = createAction(
  '[Property] Update Property',
  props<{ id: string; property: any }>()
);

export const updatePropertySuccess = createAction(
  '[Property] Update Property Success',
  props<{ property: any }>()
);

export const updatePropertyFailure = createAction(
  '[Property] Update Property Failure',
  props<{ error: any }>()
);

// Load Grouped Properties
export const loadGroupedProperties = createAction(
  '[Property] Load Grouped Properties',
  props<{ templateId: string; category: string }>()
);

export const loadGroupedPropertiesSuccess = createAction(
  '[Property] Load Grouped Properties Success',
  props<{ groupedProperties: GroupedPropertiesResponse }>()
);

export const loadGroupedPropertiesFailure = createAction(
  '[Property] Load Grouped Properties Failure',
  props<{ error: any }>()
);

// Delete Property
export const deleteProperty = createAction(
  '[Property] Delete Property',
  props<{ id: string; templateId: string }>()
);

export const deletePropertySuccess = createAction(
  '[Property] Delete Property Success',
  props<{ id: string }>()
);

export const deletePropertyFailure = createAction(
  '[Property] Delete Property Failure',
  props<{ error: any }>()
);
